import { render, staticRenderFns } from "./QuestionLayoutH.vue?vue&type=template&id=b08decc4&scoped=true&"
import script from "./QuestionLayoutH.vue?vue&type=script&lang=js&"
export * from "./QuestionLayoutH.vue?vue&type=script&lang=js&"
import style0 from "./QuestionLayoutH.vue?vue&type=style&index=0&id=b08decc4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b08decc4",
  null
  
)

export default component.exports